import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'

export class ParansNode extends BaseNode {
    next = NodeType.Dialogue
    enableSuggestions = false

    static getType(): string {
        return 'parans'
    }

    static clone(node: ParansNode): ParansNode {
        return new ParansNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(): HTMLElement {
        const dom = document.createElement('div')
        dom.className = 'parans node-style-common avoid-page-break'
        return dom
    }

    static importJSON(jsonNode: SerializedBaseNode): ParansNode {
        return new ParansNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }
}
